import { useCallback } from "react";

import { Box, Grid, Typography } from "@mui/material";
import { getOTCProduct } from "components/Marketing/OTC/OTCHelper";

import { formatPrice } from "../../../utility/formatters";

const OTCHowItWorks = ({ otcData }) => {
  const otcProduct = getOTCProduct(otcData);

  const replacePlaceholders = (text) => {
    if (!text) return "";

    const getSafeFormattedValue = (value, decimals) => {
      return value !== null && value !== undefined ? formatPrice(value, decimals) : "";
    };

    return text
      .replaceAll("{{enhancement_level}}", getSafeFormattedValue(otcData?.enhancement_level, 2))
      .replaceAll("{{event_level}}", getSafeFormattedValue(otcData?.event_level, 2))
      .replaceAll("{{quantity_accumulated}}", getSafeFormattedValue(otcData?.quantity_accumulated, 2));
  };

  const getHowItWorksTemplateLines = useCallback(() => {
    if (otcData.at_expiry) {
      return otcProduct.how_it_works_at_expiry_template.map((line) => replacePlaceholders(line));
    }

    return otcProduct.how_it_works_template.map((line) => replacePlaceholders(line));
  }, [otcProduct]);

  return (
    <Grid item xs={12}>
      <Box sx={{ p: 2, border: "1px solid", borderColor: "colors.borderUltraLightGray" }}>
        <Typography variant="body2" sx={{ mb: 1 }} color="text.secondary">
          {otcData.product_description}
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          How it works:
        </Typography>
        <Box sx={{ bgcolor: "grey.100", p: 1.5, mb: 1 }}>
          {getHowItWorksTemplateLines().map((line, index) => (
            <Typography
              key={index}
              variant="body2"
              sx={{ mb: index < getHowItWorksTemplateLines().length - 1 ? 1 : 0 }}
            >
              <li>{line}</li>
            </Typography>
          ))}
        </Box>
      </Box>
    </Grid>
  );
};

export default OTCHowItWorks;
